import { get, post } from './http-calls';
import { memoize } from 'lodash';

export const getDataByEwipNo = (wipNo) => {
    let res = get(`WorkflowJobs/GetJobsByWIPNumber/${wipNo}`, { useAuthToken: true });
    return res;
};
